// extracted by mini-css-extract-plugin
export default {"listStats":"ActivityStats--listStats--5aiTA","statValue":"ActivityStats--statValue--3T8Q8"};